interface GraphCoolConfig {
	simpleApiEndPoint: string;
	fileApiEndPoint: string;
	createUserEndPoint: string;
}

export const GRAPH_COOL_CONFIG: GraphCoolConfig = {
	simpleApiEndPoint: 'https://api.graph.cool/simple/v1/cj8sj8utc01r10170d4uoebmz',
	fileApiEndPoint: 'https://api.graph.cool/file/v1/cj8sj8utc01r10170d4uoebmz',
	createUserEndPoint: 'TEMPORARY'
};



// WEBPACK FOOTER //
// /var/www/angular/mobilit-web/src/app/config/graph-cool-variables.prod.ts